export default __webpack_public_path__ + "static/media/sb-coach-badge.54f08404.png";